import BaseActionFilter from 'yoda-core-components/lib/helpers/Analytics/BaseActionFilter';

class StyliticsActionFilter extends BaseActionFilter {
    getShopTheImageItemClick = (payload) => {
        return {
            shopTheImageID: payload.shopTheImageID,
            shopTheImagePPID: payload.shopTheImagePPID,
            moduleName: payload.moduleName,
        };
    };

    getShopTheImageLoadSuccess = (payload = {}) => {
        if (payload.page && payload.page.attributes) {
            payload.page.attributes = {
                ...payload.page.attributes,
                shopTheImageModule: 'yes',
            };
        }
        return payload;
    };

    getShopTheImageModuleClick = (payload = {}) => {
        return { shopTheImageID: payload.shopTheImageID };
    };

    getStyledForYouItemClick = (payload) => {
        return {
            styledForYouID: payload.styledForYouID,
            styledForYouPPID: payload.styledForYouPPID,
            moduleName: payload.moduleName,
        };
    };

    getStyledForYouLoadSuccess = (payload = {}) => {
        if (payload.page && payload.page.attributes) {
            payload.page.attributes = {
                ...payload.page.attributes,
                styledForYouModule: 'yes',
            };
        }
        return payload;
    };

    getStyledForYouModuleClick = (payload = {}) => {
        return { styledForYouID: payload.styledForYouID };
    };
}

export default StyliticsActionFilter;
